export const themeOptionFactory = (theme) => ({
  components: {
    EmBenchasiriPage: {
      styleOverrides: {
        detailContainer: { marginTop: "15%", width: "75%" },
        pageContainer: {
          height: "100%",
          width: "100%",
          backgroundImage: `url(https://s3.venue.in.th/dreamstime_xxl_92963113_1_1_1_d5f7aa1ed1.png)`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        },
        titleText: {
          fontWeight: 700,
          letterSpacing: "0.625rem",
          color: theme.palette.primary.contrastText,
        },
        titleWrapper: { marginBottom: theme.spacing(4) },
        descriptionText: {
          color: theme.palette.primary.contrastText,
        },
        descriptionWrapper: { marginBottom: theme.spacing(8) },
        contentContainer: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: theme.spacing(5),
        },
        ctaWrapper: {},
        eventSection: {
          display: "flex",
          height: "128px",
          gap: theme.spacing(1.25),
          overflowX: "scroll",
          width: "100%",
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
        },
        eventItemContainer: { flexBasis: "337px", flexShrink: 0 },
      },
    },
    EmBenchasiriEventCard: {
      styleOverrides: {
        root: {
          display: "block",
          width: "100%",
          height: "100%",
          borderRadius: "16px",
        },
        content: {
          display: "flex",
          gap: theme.spacing(1),
          "&:last-child": { paddingBottom: theme.spacing(2) },
        },
        media: { borderRadius: "8px", width: "30%", aspectRatio: "1" },
        textContainer: { display: "flex", flexDirection: "column" },
        titleText: {
          marginBottom: theme.spacing(1),
          fontSize: "1.125rem",
          fontWeight: 600,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
        },
        subtitleText: {},
      },
    },
  },
})
